import {
  LayoutGrid, Calculator, FileText, Gauge, Smartphone, Users, ClipboardList,
  CheckSquare, MapPin, Coins, Upload, BarChart3, Shield, Plug, Scale,
  DatabaseBackup, ShieldHalf, Briefcase,
} from "lucide-react";

// role keys: admin, foreman, project_manager, employee
export const PUNCH_MENU = [
  { to: "/tableau", tid: "tableaudebordpunch", tkey: "nav.dashboard", icon: Gauge, end: true, roles: "*", color: "gold" },
  { to: "/punch-mobile", tid: "punchmobile", tkey: "nav.punchMobile", icon: Smartphone, roles: "*", color: "red" },
  { to: "/employes", tid: "employs", tkey: "nav.employees", icon: Users, roles: ["foreman", "project_manager", "admin", "comptable"], color: "gold" },
  { to: "/feuilles", tid: "feuillesdetemps", tkey: "nav.timesheets", icon: ClipboardList, roles: "*", color: "red" },
  { to: "/approbations", tid: "approbations", tkey: "nav.approvals", icon: CheckSquare, badge: true, roles: ["foreman", "project_manager", "admin"], color: "gold" },
  { to: "/chantiers", tid: "chantiers", tkey: "nav.chantiers", icon: MapPin, roles: "*", color: "red" },
  { to: "/projets", tid: "projetshoraires", tkey: "nav.projectsSchedule", icon: Briefcase, roles: ["foreman", "project_manager", "admin"], color: "gold" },
  { to: "/codes-cout", tid: "codesdecot", tkey: "nav.costCodes", icon: Coins, roles: ["project_manager", "admin", "comptable"], color: "gold" },
  { to: "/export-paie", tid: "exportpaie", tkey: "nav.exportPayroll", icon: Upload, roles: ["admin", "comptable"], color: "red" },
  { to: "/rapports", tid: "rapports", tkey: "nav.reports", icon: BarChart3, roles: ["foreman", "project_manager", "admin", "comptable"], color: "red" },
  { to: "/securite", tid: "scurit", tkey: "nav.security", icon: Shield, roles: ["admin"], color: "gold" },
  { to: "/loi25", tid: "conformiteloi25", tkey: "nav.loi25", icon: Scale, roles: ["admin"], color: "red" },
  { to: "/conformite-ccq", tid: "conformiteccq", tkey: "nav.ccq", icon: ShieldHalf, roles: ["foreman", "project_manager", "admin", "comptable"], color: "gold" },
  { to: "/sauvegardes", tid: "sauvegardes", tkey: "nav.backups", icon: DatabaseBackup, roles: ["admin"], color: "red" },
  { to: "/integrations", tid: "intgrations", tkey: "nav.integrations", icon: Plug, roles: ["admin", "project_manager", "comptable"], hideMobile: true, color: "red" },
];

export const ECO_MENU = [
  { to: "/erp", label: "PROGÈRE ERP", icon: LayoutGrid },
  { to: "/compta", label: "PROGÈRE COMPTA", icon: Calculator },
  { to: "/devis", label: "PROGÈRE DEVIS AI", icon: FileText },
  { to: "/crm", label: "PROGÈRE CRM", icon: Users },
];

export const allowed = (roles, role) => roles === "*" || roles.includes(role);
